import FAQItems from "./FAQItems";
import { ReactComponent as Mail } from 'assets/icons/socials/Mail.svg'
import { Link } from 'react-router-dom';
import useMediaQuery from 'hooks/useMediaQuery';


const FAQSectionItems = ({ sections, sideText }) => {
    const isMobile = useMediaQuery('max-width: 640px')
    const { help_link, title, help_link_text, } = sideText
    return (
        <div className='faq-section'>
            {sections && sections.map((item, index) => (
                <div className='faq-section-items' key={index}>
                    {
                        item.tag && <div className='body1'>{item.tag}</div>
                    }
                    <FAQItems questions={item.question} />
                </div>
            ))
            }
            {
                isMobile &&
                <div className="faq-sidetext__stills">
                    <div className="body2">{title}</div>
                    <Link to={help_link} aria-label='Contact with us' className="button-text">
                        <Mail /> {help_link_text}
                    </Link>
                </div>
            }
        </div>
    );
}

export default FAQSectionItems;